<p-dialog
  [header]="settings.showCustomHeader ? 'Header' : dialogHeader"
  [(visible)]="isVisible"
  [showHeader]="settings.showHeader ?? true"
  [modal]="settings.modal ?? true"
  [position]="settings.position || 'center'"
  [maximizable]="settings.isMaximizable"
  [breakpoints]="settings.breakpoints"
  [draggable]="settings.isDraggable"
  [resizable]="settings.isResizable"
  [closeOnEscape]="settings.closeOnEscape"
  [focusOnShow]="false"
  [style]="{
    width: settings.width,
    maxWidth: settings.maxWidth,
    minWidth: settings.minWidth,
    height: settings.height,
  }"
  [styleClass]="customClass"
  (onShow)="handleOnShow()"
  (onHide)="handleOnHide()"
  (onDragEnd)="handleOnDragEnd()"
  (onMaximize)="handleOnMaximize()"
  [appendTo]="appendTo"
>
  <!-- Custom close icon -->
  <ng-template
    *ngIf="settings.useCustomCloseIcon"
    pTemplate="closeicon"
  >
    <ng-content select="[dialog-close-icon]" />
  </ng-template>
  <!-- Custom maximize icon -->
  <ng-template
    *ngIf="settings.useCustomMaximizeIcon"
    pTemplate="maximizeicon"
  >
    <ng-content select="[dialog-maximize-icon]" />
  </ng-template>
  <!-- Custom minimize icon -->
  <ng-template
    *ngIf="settings.useCustomMinimizeIcon"
    pTemplate="minimizeicon"
  >
    <ng-content select="[dialog-minimize-icon]" />
  </ng-template>

  <!-- Custom header -->
  <ng-template
    *ngIf="settings.showCustomHeader"
    pTemplate="header"
  >
    <ng-content select="[dialog-header]" />
  </ng-template>

  <!-- Custom content -->
  <ng-template
    *ngIf="settings.showCustomContent; else defaultContentTemplate"
    pTemplate="content"
  >
    <ng-content select="[dialog-content]" />
  </ng-template>
  <ng-template #defaultContentTemplate>
    <ng-content />
  </ng-template>

  <!-- Custom footer -->
  <ng-template
    *ngIf="settings.showCustomFooter"
    pTemplate="footer"
  >
    <ng-content select="[dialog-footer]" />
  </ng-template>
</p-dialog>
